<template>
  <div
    class="row_start_start w-full"
    :class="{ 'is-disabled': disabled }"
    @click="click"
  >
    <div
      class="column_start_around overflow-hidden flex-grow min-h-[110px] ml-2.5 px-2"
    >
      <div class="w-full card_text_clamp">
        <div class="title text_two_lines">
          <span v-if="cartQuantity" class="quantity quantity_inline mr-2">{{
            cartQuantity
          }}</span>
          {{ getFrontEndName(product.name) }}
        </div>
        <div v-if="displayDescription" class="card_desc text_two_lines">
          {{ displayDescription }}
        </div>
      </div>
      <div
        class="row_center_between"
        style="width: 100%; font-size: 14px; color: #fd5001"
      >
        <text>${{ product.price }}</text>
        <text
          v-if="showStock"
          class="stock_text"
          :class="{ sold_out: isSoldOut }"
        >
          {{ isSoldOut ? "售完" : `剩餘數量：${product.stockCount}` }}
        </text>
      </div>
    </div>

    <!-- 圖片區域 -->
    <div
      class="column_start_start shrink-0"
      :class="productImage ? 'w-[110px]' : 'w-0'"
    >
      <img
        v-if="productImage"
        :src="productImage"
        class="h-[110px] w-full rounded-xl"
      />
    </div>
  </div>
</template>
<script>
import { getFrontEndName } from "@/utils/productName.utils";
export default {
  props: {
    product: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
    icon: {
      type: String,
      default: "@/assets/product_example_img.png",
      required: false,
    },
    cartQuantity: {
      type: Number,
      default: 0,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    showStock() {
      return (
        Number(this.product.stockMode) === 1 &&
        this.product.stockCount !== null &&
        this.product.stockCount !== undefined
      );
    },
    isSoldOut() {
      return (
        this.product.isStockSoldOut || Number(this.product.stockCount) <= 0
      );
    },
    productImage() {
      // TODO: 之後改回從 API 取得圖片
      return this.$store.getters["product/getProductImageById"](
        this.product.id
      );
      // return require('@/assets/product_example_img.png')
    },
    productDescription() {
      // 使用新的 getter 來取得描述，會自動判斷使用哪個資料來源
      return this.$store.getters["product/getProductDescById"](this.product.id);
    },
    displayDescription() {
      return this.truncateDesc(this.productDescription);
    },
  },
  methods: {
    getFrontEndName,
    click() {
      if (this.disabled) return;
      this.$emit("click");
    },
    truncateDesc(content) {
      if (!content) return "";

      // 1. 移除 HTML 標籤
      let text = content.replace(/<[^>]*>/g, "").trim();

      // 2. 解碼 HTML 實體字符
      const textarea = document.createElement("textarea");
      textarea.innerHTML = text;
      text = textarea.value;

      return text;
    },
  },
};
</script>
<style lang="scss">
.quantity_container {
  border-radius: 50%;
  width: 0px;
  height: 0px;
  position: relative;
  top: 0;
  left: 0;
}

.quantity {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  background-color: #d60a0a;
  flex-shrink: 0;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  font-family: PingFang SC;
}

.stock_text {
  color: #666666;
  font-size: 13px;
}

.stock_text.sold_out {
  color: #d60a0a;
}

.quantity_inline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}

/* 名稱最多 2 行、說明最多 2 行，且總高只容得下「名稱 2 行 + 說明 1 行」，
   因此名稱佔 2 行時說明自動只剩 1 行。全部用 em 綁定，系統字體放大時等比縮放。
   注意：本容器不可加 padding，box-sizing 為 border-box 會吃掉 max-height 額度。 */
.card_text_clamp {
  font-size: 20px;
  /* 額度 = 名稱 2 行 (1.4em×2) + 說明 1 行 (1.12em) + 間隔與捨入容錯 (0.3em + 0.1em)。
     此處 em 以本容器的 20px 為基準；.card_desc 的 margin-top 則以說明自身字級為基準
     (0.3em × 14px = 4.2px)，比這裡預留的 6px 小，餘裕不足一行故不會露出半行。 */
  max-height: calc(1.4em * 2 + 1.12em + 0.3em + 0.1em);
  overflow: hidden;
}

.card_text_clamp .title {
  font-size: 1em;
  line-height: 1.4;
}

.card_text_clamp .card_desc {
  font-size: 0.7em;
  line-height: 1.6;
  color: #666666;
  /* 與名稱的間隔（0.3em × 14px = 4.2px）；
     加大此值時 .card_text_clamp 的 max-height 要同步加大，否則說明會少一行 */
  margin-top: 0.3em;
}

.is-disabled {
  opacity: 0.45;
}
</style>
